import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchProfile, setLoading } from "../profileSlice";

export default function useInitProfile() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("QC_accessToken");

    if (token) {
      const loadProfile = async () => {
        try {
          await dispatch(fetchProfile());
        } catch (error) {
          console.error("Failed to load profile:", error);
        }
      };
      loadProfile();
    } else {
      // If no token, we're not authenticated, so set loading to false immediately
      dispatch(setLoading(false));
    }
  }, [dispatch]);
}
